import { action } from 'satcheljs';

/**
 * Called when we select discard, resets the birthday calendar options in store
 */
export const discardBirthdayCalendarOption = action('discardBirthdayCalendarOption', () => ({}));

/**
 * Called when there is a change in the birthday calendar option - Current State
 */
export const updateBirthdayCalendarCurrentState = action(
    'updateBirthdayCalendarCurrentState',
    (birthdayCalendarEnabled: boolean) => ({
        birthdayCalendarEnabled,
    })
);

/**
 * Called when there is a change in the birthday calendar option - Initial State
 */
export const updateBirthdayCalendarInitialState = action(
    'updateBirthdayCalendarInitialState',
    (birthdayCalendarEnabled: boolean) => ({
        birthdayCalendarEnabled,
    })
);
